import React from "react";
import "./App.scss";
import AppRoutes from "navigation/AppRoutes";
import Navbar from "components/common/Navbar/Navbar";
import Footer from "components/common/Footer/Footer";
import AppWrapper from "./navigation/AppWrapper";

function App() {
  return (
    <>
      <Navbar />
      <AppWrapper>
        <AppRoutes />
      </AppWrapper>
      <Footer />
    </>
  );
}

export default App;
